import SlideSelect from '../../../../../../shared/Inputs/SlideSelect'
import checkpointVisibilityOptions, { CheckpointVisibility } from '../checkpointVisibilityOptions'

interface IProps {
  selectedOption: CheckpointVisibility
  onSelect: (value: CheckpointVisibility) => void
  name?: string
}

const CheckpointVisibilitySlideSelect = (props: IProps) => {
  return <SlideSelect options={checkpointVisibilityOptions} {...props} />
}

export default CheckpointVisibilitySlideSelect
